<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--onboarding">
    <main class="l-main">
      <div class="l-main-head">
        <div class="p-onboarding-progress">
          <div class="p-onboarding-progress__title">
            <div class="c-text">STEP.2</div>
          </div>
          <div class="p-onboarding-progress__content">
            <h1 class="c-title">
              <div class="c-title__text u-fs40">プロジェクト作成</div>
            </h1>
            <div class="c-progress">
              <ul class="c-progress-list">
                <li class="c-progress-list__item">導入準備</li>
                <li class="c-progress-list__item is-current">プロジェクト作成</li>
                <!-- <li class="c-progress-list__item">テスト配信</li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-onboarding__outline">
          <div class="c-text">
            プッシュ通知を行うWebサイト（ドメイン）の設定を行いプロジェクトを作成します。<br />
            Step1でFirebaseから取得した情報の設定も合わせて行います。<br />
            ※ 作成するプロジェクトは、PUSH ONEサービス内で使われるプロジェクトになります。Firebaseで作成したプロジェクトと別になりますことをご注意ください。<br />
          </div>
        </div>
        <form action="/api/project/edit" method="post">
          <div class="p-onboarding-project">
            <div class="p-project-edit">
              <ul class="p-project-edit-list">
                <li class="p-project-edit-list__item">
                  <ValidatableTextInput
                    :title="'プロジェクト名'"
                    :description="'PUSH ONEサービス内で使われるプロジェクトになりますので、Firebaseで作成したプロジェクトとは別の名前で問題ございません。'"
                    :placeholder="'プロジェクト名を入力してください'"
                    :data="project.name"
                    :error-message="getErrorMessage('project.name')"
                    @value-changed="project.name = $event"
                  />
                </li>
                <li class="p-project-edit-list__item">
                  <ValidatableTextInput
                    :title="'ご利用サイトドメイン'"
                    :description="'プッシュ通知の許可を取得するドメイン（サイトURL）を記載下さい。'"
                    :placeholder="'例）https://webpush.jp/'"
                    :data="project.domain"
                    :error-message="getErrorMessage('project.domain')"
                    @value-changed="project.domain = $event"
                  />
                </li>
                <li class="p-project-edit-list__item">
                  <div class="p-message-edit-list__item">
                    <div class="c-select-card">
                      <div class="c-select-card__title">プッシュの対象</div>
                      <ul class="c-select-card-list">
                        <li class="c-select-card-list__item">
                          <label class="c-select-card__label">
                            <input
                              type="radio"
                              name="push_type"
                              value="1"
                              checked="checked"
                            />
                            <div class="c-select-card__item u-h150">
                              <div class="c-select-card-content">
                                <div class="c-select-card-content__title">ブラウザプッシュ</div>
                                <div class="c-select-card-content__text">
                                  Webサイトアクセス時に通知を許可したユーザーへアプリ同様のプッシュ通知が行えます。通知許可を行ったユーザーにはWebサイトへアクセスしていないタイミングでも通知を送ることができます。
                                </div>
                              </div>
                            </div>
                          </label>
                        </li>
                      </ul>
                      <div class="c-error c-error--balloon">
                        <div class="c-error__text"></div>
                      </div>
                    </div>
                  </div>
                </li>
                <!-- メッセージアイコン -->
                <li class="p-project-edit-list__item">
                  <div class="c-upload">
                    <div class="c-upload__title">メッセージアイコン</div>
                    <div class="c-upload__text">プッシュ通知メッセージの際にデフォルトで設定される画像のアイコンになります。</div>
                    <label class="c-upload__label">
                      <div class="c-upload__image">
                        <img
                          v-show="attachement.data && attachement.data != ''"
                          :src="attachement.data"
                        />
                        <div v-show="!attachement.data" class="c-upload__noimage">
                          <div class="c-icon c-icon--gray-3 u-wh30">
                            <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <use xlink:href="/assets/img/sprite.svg#photo" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div class="c-upload__data">
                        <input
                          type="file"
                          name="message_icon"
                          value=""
                          placeholder="ファイルの選択"
                          @change="onFileChange"
                        />
                        <span class="c-upload__btn">ファイルの選択</span>
                        <div class="c-upload__filename">{{ attachement.name }}</div>
                        <div class="c-upload__text c-upload__text--spec">
                          ※サイズは縦x横：64x64px～192x192px、容量：5KB以内奨励(最大8KB)、形式：PNG奨励(JPG,JPEG可)
                        </div>
                      </div>
                    </label>
                    <div
                      class="c-error c-error--balloon c-error--upload-badge"
                      :class="{ 'is-active': getErrorMessage('attachement.data') }"
                    >
                      <div class="c-error__text">{{ getErrorMessage('attachement.data') }}</div>
                    </div>
                  </div>
                </li>
                <!-- /メッセージアイコン -->
                <!-- バッジ画像 -->
                <li class="p-project-edit-list__item">
                  <div class="c-upload">
                    <div class="c-upload__title">ステータスアイコン</div>
                    <div class="c-upload__text">
                      通知受信時に通常はChromeアイコンになりますがアイコンを登録することで、オリジナルのアイコンを表示頂けます。</div>
                    <label class="c-upload__label">
                      <div class="c-upload__image">
                        <img
                          v-show="attachementBadge.data && attachementBadge.data != ''"
                          :src="attachementBadge.data"
                        />
                        <div v-show="!attachementBadge.data" class="c-upload__noimage">
                          <div class="c-icon c-icon--gray-3 u-wh30">
                            <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <use xlink:href="/assets/img/sprite.svg#photo" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div class="c-upload__data">
                        <input
                          type="file"
                          name="message_badge"
                          value=""
                          placeholder="ファイルの選択"
                          @change="onBadgeFileChange"
                        />
                        <span class="c-upload__btn">ファイルの選択</span>
                        <div class="c-upload__filename">{{ attachementBadge.name }}</div>
                        <div class="c-upload__text c-upload__text--spec">
                          ※サイズは縦x横：72x72px～128x128px、容量：5KB以内奨励(最大8KB)、形式：PNG
                        </div>
                      </div>
                    </label>
                    <div
                      class="c-error c-error--balloon c-error--upload-badge"
                      :class="{ 'is-active': getErrorMessage('attachementBadge.data') }"
                    >
                      <div class="c-error__text">{{ getErrorMessage('attachementBadge.data') }}
                      </div>
                    </div>
                  </div>
                </li>
                <!-- /バッジ画像 -->
                <li class="p-project-edit-list__item">
                  <div class="c-radio">
                    <div class="c-radio__title">DMP利用状況</div>
                    <div class="c-radio__text">DMP連携と連携していません</div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="p-project-edit p-project-edit--readonly p-project-edit--firebase">
              <div class="c-title c-title--left">
                <div class="c-image u-w230"><img src="/assets/img/logo-firebase--standard.svg" /></div>
                <div class="c-text">Google Firebase と連携している設定情報を表示しています</div>
                <GrayButton
                  :text="'Firebaseからコピー'"
                  :add-style="'width:280px;'"
                  @button-click="showCopyPopup"
                />
              </div>
              <ul class="p-project-edit-list">
                <li class="p-project-edit-list__item">
                  <ValidatableTextInput
                    ref="senderId"
                    :title="'送信者ID'"
                    :is-horizontal="true"
                    :data="firebase.senderId"
                    :error-message="getErrorMessage('firebase.senderId')"
                    @value-changed="firebase.senderId = $event"
                  />
                </li>
                <li class="p-project-edit-list__item">
                  <ValidatableTextInput
                    ref="apiKey"
                    :title="'APIKey'"
                    :is-horizontal="true"
                    :data="firebase.apiKey"
                    :error-message="getErrorMessage('firebase.apiKey')"
                    @value-changed="firebase.apiKey = $event"
                  />
                </li>
                <li class="p-project-edit-list__item">
                  <ValidatableTextInput
                    ref="projectId"
                    :title="'プロジェクトID'"
                    :is-horizontal="true"
                    :data="firebase.projectId"
                    :error-message="getErrorMessage('firebase.projectId')"
                    @value-changed="firebase.projectId = $event"
                  />
                </li>
                <li class="p-project-edit-list__item">
                  <ValidatableTextInput
                    ref="appId"
                    :title="'アプリID'"
                    :is-horizontal="true"
                    :data="firebase.appId"
                    :error-message="getErrorMessage('firebase.appId')"
                    @value-changed="firebase.appId = $event"
                  />
                </li>
                <li class="p-project-edit-list__item">
                  <FirebaseServiceKeyInput
                    :service-account-key="firebase.serviceAccountKey"
                    :error-message="getErrorMessage('firebase.serviceAccountKey')"
                    @service-account-changed="firebase.serviceAccountKey = $event"
                  />
                </li>
                <li class="p-project-edit-list__item">
                  <ValidatableTextInput
                    :title="'ウェブプッシュ証明書\n（鍵ペア）'"
                    :is-horizontal="true"
                    :data="firebase.vapId"
                    :error-message="getErrorMessage('firebase.vapId')"
                    @value-changed="firebase.vapId = $event"
                  />
                </li>
              </ul>
            </div>
            <div class="p-onboarding-btns">

              <a class="c-btn c-btn--gray u-w180 u-h50 u-fs--xl" @click="onPreviousClick($event)">
                <p class="c-btn__text">前に戻る</p>
              </a>

              <button
                class="c-btn c-btn--modal c-btn--blue u-w320 u-h50 u-fs--xl"
                type="button"
                name="edit"
                value="edit"
                :class="{ 'is-loading': isProcessing }"
                :disabled="isProcessing"
                @click="onNextClick($event)"
              >
                <p class="c-btn__text">プロジェクトを登録する</p>
              </button>
            </div>
          </div>
        </form>
      </div>
    </main>
    <FirebaseCopyPopup ref="popup" @apply-config="applyFirebaseConfig($event)" />
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message="'入力を確認してください'"
      :on-close-click="() => isError = false"
    />
  </div><!-- /ページ内容 -->
</template>

<script>
import axios from 'axios';
import GrayButton from '../atoms/GrayButton.vue';
import FirebaseCopyPopup from '../organisms/FirebaseCopyPopup.vue';
import ValidatableTextInput from '../molecules/ValidatableTextInput.vue';

export default {
  components: { GrayButton, FirebaseCopyPopup, ValidatableTextInput },
  props: {
    nextUrl: String,
    previousUrl: String
  },
  data() {
    return {
      project: {
        name: '',
        domain: ''
      },
      firebase: {
        senderId: '',
        serviceAccountKey: '',
        vapId: '',
        apiKey: '',
        projectId: '',
        appId: ''
      },
      attachement: {
        data: '',
        name: ''
      },
      attachementBadge: {
        data: '',
        name: '',
        url: ''
      },
      errors: {},
      isProcessing: false,
      acceptableMimeTypes: [
        'image/png',
        'image/jpeg',
        'image/gif',
      ],
      isError: false,
    }
  },
  methods: {
    isAcceptableMimeType: function (mimeType) {
      var isAcceptable = false;
      this.acceptableMimeTypes.forEach(function (acceptableMimeType) {
        if (acceptableMimeType == mimeType) {
          isAcceptable = true;
        }
      });
      return isAcceptable;
    },
    getErrorMessage: function (key) {
      var error = this.errors[key];
      return error ? error[0] : '';
    },
    onNextClick: function (_event) {
      this.save();
    },
    onPreviousClick: function (_event) {
      location.href = this.previousUrl;
    },
    onFileChange: function (event) {
      const file = event.target.files[0];
      delete this.errors['attachement.data'];

      if (!this.isAcceptableMimeType(file.type)) {
        this.errors['attachement.data'] = ['メッセージアイコンはPNG/JPEG/GIF形式のファイルを指定してください。'];
        this.$forceUpdate();
        return;
      }

      const fileReader = new FileReader();
      const self = this;

      fileReader.onload = () => {
        const offset = fileReader.result.indexOf(",") + 1;
        const base64 = fileReader.result.slice(offset);
        const data = `data:${file.type};base64,${base64}`;
        const params = {
          data: data,
          max_size: 192,
          max_bytes: 8192
        }
        self.optimizeImage(params, function (optimizedImage) {
          if (optimizedImage) {
            if (optimizedImage.filesize > 8192) { // 8KB
              self.errors['attachement.data'] = ['メッセージアイコンは8KB以下のファイルを指定してください。'];
              self.$forceUpdate();
              return;
            }
            self.attachement.data = optimizedImage.data;
          } else {
            if (file.size > 8192) { // 8KB
              self.errors['attachement.data'] = ['メッセージアイコンは8KB以下のファイルを指定してください。'];
              self.$forceUpdate();
              return;
            }
            this.attachement.data = data;
          }
          self.attachement.name = file.name;
        });
      };
      fileReader.readAsDataURL(file);
    },
    onBadgeFileChange: async function (event) {
      const file = event.target.files[0];
      delete this.errors['attachementBadge.data'];

      if (file.type != 'image/png') {
        this.errors['attachementBadge.data'] = ['ステータスアイコンはPNG形式のファイルを指定してください。'];
        this.$forceUpdate();
        return;
      }

      const fileReader = new FileReader();
      const self = this;

      const isTransparency = await self.checkTransparency(file);
      if (!isTransparency) {
        self.errors['attachementBadge.data'] = ['ステータスアイコンは透過PNG形式のファイルを指定してください。'];
        this.$forceUpdate();
        return;
      }

      fileReader.onload = () => {
        const offset = fileReader.result.indexOf(",") + 1;
        const base64 = fileReader.result.slice(offset);
        const data = `data:${file.type};base64,${base64}`;

        const params = {
          data: data,
          max_size: 128,
          max_bytes: 8192
        }
        self.optimizeImage(params, function (optimizedImage) {
          if (optimizedImage) {
            if (optimizedImage.filesize > 8192) { // 8KB
              self.errors['attachementBadge.data'] = ['ステータスアイコンは8KB以下のファイルを指定してください。'];
              self.$forceUpdate();
              return;
            }
            self.attachementBadge.data = optimizedImage.data;
          } else {
            if (file.size > 8192) { // 8KB
              self.errors['attachementBadge.data'] = ['ステータスアイコンは8KB以下のファイルを指定してください。'];
              self.$forceUpdate();
              return;
            }
            this.attachementBadge.data = data;
          }
          self.attachementBadge.name = file.name;
        });
      };
      fileReader.readAsDataURL(file);
    },
    save: function () {
      const self = this;
      const data = {
        serviceTypes: ['2'],
        project: this.project,
        firebase: this.firebase,
        attachement: this.attachement
      }
      if (this.attachementBadge.name) {
        data.attachementBadge = this.attachementBadge;
      }

      self.isProcessing = true;

      axios.post('/api/projects', data)
        .then(_res => {
          location.href = self.nextUrl;
        })
        .catch(e => {
          self.errors = e.response.data.errors;
          self.isProcessing = false;
          self.isError = true;
        });
    },
    showCopyPopup: function () {
      this.$refs.popup.open();
    },
    applyFirebaseConfig: function (config) {
      this.$refs.senderId.changeValue(config.messagingSenderId);
      this.$refs.apiKey.changeValue(config.apiKey);
      this.$refs.projectId.changeValue(config.projectId);
      this.$refs.appId.changeValue(config.appId);
    },
    optimizeImage: function (params, callback) {
      const endpoint = 'https://bpjflajowoc3zds6vfdqnhcfs40irvbj.lambda-url.ap-northeast-1.on.aws';
      axios.post(endpoint, params)
        .then(res => {
          callback(res.data);
        })
        .catch(_e => {
          callback(null);
        });
    },
    checkTransparency: async function (file) {
      const image = await this.loadImage(file);
      return await this.checkImageTransparency(image);
    },
    loadImage(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = (e) => reject(e);
          img.src = reader.result;
        };

        reader.onerror = (e) => reject(e);
        reader.readAsDataURL(file);
      });
    },
    checkImageTransparency(img) {
      return new Promise((resolve, _reject) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const alphaChannel = imageData.data.filter((_, i) => (i + 1) % 4 === 0);

        if (alphaChannel.some((alpha) => alpha !== 255)) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
  },
}
</script>
